import React from 'react';

export default function AthletePerformance() {
    return (
        <div>
            <text className='submit-green small'>Viewing athletes workouts comming soon</text>
        </div>
    )
}
